<div class="c-modal__backdrop" (click)="dismiss()">
</div>
<div class="c-modal" [class.c-modal--center]="center" [class.c-modal--short]="short"
  [class.c-modal--input]="mode === 'input'">
  <button *ngIf="hasClose" class="c-modal__close" (click)="dismiss()"></button>
  <ng-content></ng-content>
</div>